import { useLocation } from "react-router-dom";

export function useIsSupportPage() {
  const { pathname } = useLocation();

  return pathname.includes("/support");
}

export default useIsSupportPage;

